import { FormattedMessage } from 'react-intl';
import { NavLink, Link } from 'react-router-dom';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import IframeResizer from 'iframe-resizer-react';

import {
    ROUTE_GENERAL_SETTINGS,
    ROUTE_MISSION_PROGRESS,
    ROUTE_INFRASTRUCTURE,
    ROUTE_MISSIONS,
    ROUTE_VEHICLES,
    ROUTE_STATISTICS,
} from '../../routes/Router';
import { config } from '../../config';

const AppHeader = () => {
    const navItems = [
        {
            key: 'missions',
            route: (
                <NavLink to={ROUTE_MISSIONS}>
                    <FormattedMessage id="i18n.missions.title" />
                </NavLink>
            ),
        },
        {
            key: 'vehicles',
            route: (
                <NavLink to={ROUTE_VEHICLES}>
                    <FormattedMessage id="i18n.fleet.title" />
                </NavLink>
            ),
        },
        {
            key: 'general-settings',
            route: (
                <NavLink to={ROUTE_GENERAL_SETTINGS}>
                    <FormattedMessage id="i18n.generalSetting.title" />
                </NavLink>
            ),
        },
        {
            key: 'infrastructure',
            route: (
                <NavLink to={ROUTE_INFRASTRUCTURE}>
                    <FormattedMessage id="i18n.infrastructure.title" />
                </NavLink>
            ),
        },
        {
            key: 'mission-progress',
            route: (
                <NavLink to={ROUTE_MISSION_PROGRESS}>
                    <FormattedMessage id="i18n.missionProgress.title" />
                </NavLink>
            ),
        },
        {
            key: 'statistics',
            route: (
                <NavLink to={ROUTE_STATISTICS}>
                    <FormattedMessage id="i18n.statistics.statistics" />
                </NavLink>
            ),
        },
    ];

    const environment = import.meta.env.PROD ? 'production' : 'local';

    const notifications = <RioNotifications />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;

    return (
        <ApplicationHeader
            label={<FormattedMessage id="i18n.projectName" />}
            appNavigator={<IframeResizer className="iFrameResizer" src={config.backend.MENU_SERVICE} />}
            homeRoute={<Link to={config.homeRoute || ''} />}
            navItems={navItems}
            actionBarItems={[notifications, userMenuItem]}
        />
    );
};

export default AppHeader;
